

export class UserAddApplicationModuleInput implements IUserAddApplicationModuleInput {
    /** The auto-generated id of the application module */
    applicationModuleId!: number;

    constructor(data?: IUserAddApplicationModuleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationModuleId = _data["applicationModuleId"];
        }
    }

    static fromJS(data: any): UserAddApplicationModuleInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddApplicationModuleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationModuleId"] = this.applicationModuleId;
        return data; 
    }
}

export interface IUserAddApplicationModuleInput {
    /** The auto-generated id of the application module */
    applicationModuleId: number;
}

